import React, { useMemo } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { useCountriesUIContext } from "../CountriesUIContext";

const prepareFilter = (queryParams, values) => {
  const { type, searchText } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};
  // Filter by status
  // Filter by type
  const type1 = type !== "" ? +type : 0;
  // Filter by all fields
  if (searchText) {
    if(type1===0) {
      filter.fullName = searchText;
    } else if(type1===1) {
      filter.code = searchText;
    } else {
      filter._id = searchText;

    }
  }
  newQueryParams.filter = filter;
  return newQueryParams;
};

export function CountriesFilter({ listLoading }) {
  // Countries UI Context
  const countriesUIContext = useCountriesUIContext();
  const countriesUIProps = useMemo(() => {
    return {
      queryParams: countriesUIContext.queryParams,
      setQueryParams: countriesUIContext.setQueryParams,
    };
  }, [countriesUIContext]);

  // queryParams, setQueryParams,
  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(countriesUIProps.queryParams, values);
    if (!isEqual(newQueryParams, countriesUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      // update list by queryParams
      countriesUIProps.setQueryParams(newQueryParams);
    }
  };

  return (
    <>
      <Formik
        initialValues={{
          status: "", // values => All=""/Susspended=0/Active=1/Pending=2
          type: "", // values => All=""/Business=0/Individual=1
          searchText: "",
        }}
        onSubmit={(values) => {
          applyFilter(values);
        }}
      >
        {({
          values,
          handleSubmit,
          handleBlur,
          handleChange,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit} className="form form-label-right">
            <div className="form-group row">
              <div className="col-lg-2">
                <select
                  className="form-control"
                  placeholder="Choose Filter Field"
                  name="type"
                  onBlur={handleBlur}
                  onChange={(e) => {
                    setFieldValue("type", e.target.value);
                    handleSubmit();
                  }}
                  value={values.type}
                >
                  <option value="0">Country Name</option>
                  <option value="1">Country Code</option>
                  <option value="2">ID</option>
                </select>
                <small className="form-text text-muted">
                  <b>Filter</b> by Field
                </small>
              </div>
              <div className="col-lg-2">
                <input
                  type="text"
                  className="form-control"
                  name="searchText"
                  placeholder="Search"
                  onBlur={handleBlur}
                  value={values.searchText}
                  onChange={(e) => {
                    setFieldValue("searchText", e.target.value);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  <b>Search</b> in the specific field
                </small>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </>
  );
}
